export default __webpack_public_path__ + "static/media/contact.0c41aec7.jpg";